const campaignRTLStyles = {
  '.iconMessage': {
    right: 'auto !important',
    left: '30px',
  },
  '.iconMessageAvatar': {
    marginRight: '0 !important',
    marginLeft: '10px',
  },
  '.iconMessageClose': {
    right: 'auto !important',
    left: '-10px',
  },
};

export default campaignRTLStyles;
